import {SkeletonBox, SkeletonText} from '@primer/react/experimental'
import {CommentContentSkeleton} from '@github-ui/diff-lines/comment-content-skeleton'
import styles from './ThreadPreviewSkeleton.module.css'

interface ThreadPreviewSkeletonProps {
  /**
   * Number of skeleton items to render
   * @default 1
   */
  count?: number
}

/**
 * A single thread preview skeleton that mimics the ThreadPreview component structure
 */
function ThreadPreviewSkeletonItem() {
  return (
    <div className={styles.container} data-testid="thread-preview-skeleton-item">
      {/* Header */}
      <div className={styles.header}>
        <SkeletonText size="bodyMedium" className={styles.filePath} />
      </div>

      {/* Diff Preview */}
      <div className={styles.diffPreview}>
        <div className={styles.diffLine}>
          <SkeletonBox className={styles.lineNumberCol} />
          <SkeletonBox className={styles.diffContent} />
        </div>
        <div className={styles.diffLine}>
          <SkeletonBox className={styles.lineNumberCol} />
          <SkeletonBox className={styles.diffContent} />
        </div>
        <div className={styles.diffLine}>
          <SkeletonBox className={styles.lineNumberCol} />
          <SkeletonBox className={styles.diffContent} />
        </div>
      </div>

      <CommentContentSkeleton />
    </div>
  )
}

/**
 * Renders skeleton loading states for thread previews.
 * Used as a fallback while thread preview data is being fetched.
 */
export function ThreadPreviewSkeleton({count = 1}: ThreadPreviewSkeletonProps) {
  return (
    <div className="d-flex flex-column position-relative width-full gap-3" data-testid="thread-preview-skeleton">
      {Array.from({length: count}, (_, index) => (
        <ThreadPreviewSkeletonItem key={index} />
      ))}
    </div>
  )
}
